var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4413 12.795H13.785L12 9.85876H19.2113L20.7113 12.3225C20.74 12.37 20.7556 12.4243 20.7563 12.4798C20.757 12.5353 20.7428 12.59 20.7153 12.6382C20.6877 12.6864 20.6478 12.7264 20.5996 12.7539C20.5514 12.7815 20.4968 12.7957 20.4413 12.795Z",
    fill: "#156CDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 9.85876H4.78906V17.0775H12.0003V9.85876Z",
    fill: "#DFE8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78906 11.22V12.795L6.99781 15.0075C8.32524 16.333 10.1244 17.0775 12.0003 17.0775V9.85876H8.68531L4.78906 11.22Z",
    fill: "#CCD8E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2073 9.85876H11.9961V17.0775H19.2073V9.85876Z",
    fill: "#0795FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2075 11.22V12.795L16.9988 15.0075C15.6718 16.3314 13.8744 17.0757 12 17.0775V9.85876H19.2113L19.2075 11.22Z",
    fill: "#156CDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 9.85874H4.78917L3.28917 7.39499C3.26057 7.34778 3.24505 7.29382 3.24418 7.23863C3.24331 7.18344 3.25713 7.12902 3.28423 7.08094C3.31132 7.03285 3.35072 6.99284 3.39837 6.965C3.44602 6.93715 3.50022 6.92248 3.55542 6.92249H10.0429C10.0965 6.92248 10.1491 6.93628 10.1957 6.96256C10.2424 6.98884 10.2814 7.0267 10.3092 7.07249L12.0004 9.85874Z",
    fill: "#CCD8E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55918 12.795H10.0429C10.0965 12.795 10.1491 12.7812 10.1957 12.7549C10.2424 12.7287 10.2814 12.6908 10.3092 12.645L12.0004 9.85876H4.78918L3.28918 12.3225C3.26042 12.37 3.24487 12.4243 3.24417 12.4798C3.24346 12.5353 3.25761 12.59 3.28515 12.6382C3.31269 12.6864 3.35262 12.7264 3.40081 12.7539C3.44899 12.7815 3.50367 12.7957 3.55918 12.795Z",
    fill: "#DFE8F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.85874H19.2113L20.7113 7.39499C20.7398 7.34778 20.7554 7.29382 20.7562 7.23863C20.7571 7.18344 20.7433 7.12902 20.7162 7.08094C20.6891 7.03285 20.6497 6.99284 20.602 6.965C20.5544 6.93715 20.5002 6.92248 20.445 6.92249H13.9575C13.904 6.92248 13.8513 6.93628 13.8047 6.96256C13.7581 6.98884 13.719 7.0267 13.6912 7.07249L12 9.85874Z",
    fill: "#156CDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPack);
export default __webpack_public_path__ + "static/media/icon-pack.08aa13d3a1eb2f67d7650ffe04274abd.svg";
export { ForwardRef as ReactComponent };